<!-- Start Breadcrumbs -->
<!-- <app-breadcrumbs [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs> -->
<!-- End Breadcrumbs -->

<!-- <div class="row">
	<div class="col-lg-12">
		<div class="card" id="blackoutDaysList">
			<div class="card-body border border-dashed border-end-0 border-start-0">
				<div class="margin-top-2">
					<app-campaign-week-board></app-campaign-week-board>
				</div>
			</div>
		</div>
	</div>
</div> -->

<div id="blackoutDaysList">
	<app-campaign-week-board></app-campaign-week-board>
</div>
